import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';

export interface HeaderProps {
    title?: string;
    addNewUrl: string;
    toolbar?: React.ReactNode;
    showAdd: boolean;
    showSecondaryButton: boolean;
    pageCaption?: string;
    showHeader?: boolean;
    addButtonLabel?: string;
    secondaryButtonLabel?: string;
    entityForCaptionText?: string;
    secondaryButtonUrl: string;
}

const getHeaderCaptionEntity = (
    entityForCaptionText: string | undefined,
    title: string | undefined
) => {
    if (!entityForCaptionText) {
        return `${title ? title.toLowerCase() : ''}`;
    }

    return entityForCaptionText.toLowerCase();
};

const ListPageHeader = ({
    title,
    addNewUrl,
    secondaryButtonUrl = '',
    toolbar,
    showAdd,
    showSecondaryButton,
    pageCaption,
    showHeader = true,
    addButtonLabel = '',
    secondaryButtonLabel = '',
    entityForCaptionText = '',
}: HeaderProps): JSX.Element => {
    const history = useHistory();
    return (
        <Box>
            <Box
                sx={{
                    mt: showHeader ? 2 : 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                {showHeader && (
                    <Typography
                        id="list-page-header-title"
                        variant="h5"
                        component="h1"
                    >
                        {title}
                    </Typography>
                )}
                <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
                    {showSecondaryButton && (
                        <Button
                            id="secondary-action-button"
                            variant="outlined"
                            color="secondary"
                            onClick={(): void => {
                                history.push(secondaryButtonUrl);
                            }}
                        >
                            {secondaryButtonLabel}
                        </Button>
                    )}
                    {showAdd && (
                        <Button
                            id={'add-new-item-button'}
                            variant="contained"
                            onClick={(): void => {
                                history.push(addNewUrl);
                            }}
                        >
                            {!addButtonLabel ? 'Add new' : addButtonLabel}
                        </Button>
                    )}
                </Stack>
            </Box>
            {showHeader && <Divider sx={{ my: 2 }} />}
            <Box>{toolbar}</Box>
            {pageCaption ? (
                <Box sx={{ mt: 2 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'text.secondary',
                        }}
                    >
                        Showing {pageCaption}{' '}
                        {getHeaderCaptionEntity(entityForCaptionText, title)}
                    </Typography>
                </Box>
            ) : null}
        </Box>
    );
};

export default ListPageHeader;
